export default function() {
  const widgetName = 'footerContact';
  const widgetOpts = footerContactOpts;

  function buildItem(item) {
    let url = item.URL ? item.URL.toString() : '';
    // remove http:// from URL
    if (url && url.indexOf('http://') === 0) {
      url = url.replace('http://', '');
    }
    const title = item.Description;
    const icon = item.ImageWithPath.toString();
    const template = `
    <li>
      <i style="background-image:url('${icon}')"></i>
      <a ${url ? `href="${url}"` : ``} ${url.includes('maps') || url.includes('pdf') ? `target="blank_"` : ``}>${title}</a>
    </li>
    `;
    return template;
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const items = data.items.map(item => buildItem(item));
      $(`#${widgetName}`).empty().append(items);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true
  });

}